import axios from "axios";

const REGION = "us-east-2";
const BUCKET = "airtableuploads";
export type FileResponseType = "arraybuffer" | "blob" | "json" | "text";

export namespace AWS {
	export namespace S3 {
		export async function download<T = ArrayBuffer | Blob | string>(
			filename: string,
			responseType: FileResponseType,
			recordId = "",
			bucket: string = BUCKET,
		) {
			try {
				const url = _makeS3Url(filename, recordId, bucket);
				const response = await axios.get<T>(url, { responseType });
				if (response.status === 200) return response.data;
			} catch {
				// try from root folder
				const url2 = _makeS3Url(filename, "", bucket);
				const response2 = await axios.get<T>(url2, { responseType });
				if (response2.status === 200) return response2.data;
			}
		}

		function _makeS3Url(filename: string, folder = "", bucket: string = BUCKET) {
			folder = folder == "" ? "" : folder.endsWith("/") ? folder : `${folder}/`;
			filename = _isEncoded(filename) ? filename : encodeURIComponent(filename);
			return `https://${bucket}.s3.${REGION}.amazonaws.com/${folder}${filename}`;
		}

		function _isEncoded(uri: string) {
			uri = uri || "";

			return uri !== decodeURIComponent(uri);
		}
	}
}
